import React, { Fragment, useState, useContext, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Menu from '@material-ui/core/Menu';
import Forms from '@mummssoftware/forms';
import BookIcon from '@material-ui/icons/Book';
import {
  GlobalContext,
  OPEN_WIDGET,
  CLOSE_WIDGET,
} from '@mummssoftware/global-context/GlobalContext';
import { Forms as FormsWidget } from '@mummssoftware/utils/constants';
import { Context } from '../../context';
import { FORM_NAME } from '../Context/constants';
import { StyledActionIcon } from '../../components';
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary';

const ITEM_HEIGHT = 50;
const useStyles = makeStyles(() => ({
  menuPaper: {
    height: '86vh',
    maxHeight: ITEM_HEIGHT * 10,
    width: 380,
    overflow: 'hidden',
  },
  menuList: {
    paddingTop: '0px',
  },
}));

/**
 * Opens Forms from the patient-dashboard lower ribbon. Forms has `doNotShow: true`
 * in widget config — not a grid tile or + menu item; see
 * `widgetConfig/buildPutWidgetConfigPayload.ts`.
 */
export const FormListMenu = () => {
  const globalContext = useContext(GlobalContext);
  const { widgetsOpen, widgetNamesOpen } = useContext(GlobalContext);

  const { pim, agency, keycloak } = useContext(Context);
  const [isWidgetOpen, setWidgetOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const classes = useStyles();

  useEffect(() => {
    // max open widget is 4
    if (widgetsOpen.length >= 4) {
      setWidgetOpen(true);
    }
    if (widgetNamesOpen.includes(FormsWidget)) {
      setWidgetOpen(true);
    } else {
      setWidgetOpen(false);
    }
  }, [widgetsOpen, widgetNamesOpen]);

  const onOpen = (e: any) => {
    // clean form name
    localStorage.removeItem(FORM_NAME);
    setAnchorEl(e.currentTarget);
  };

  const onClose = () => {
    const widgetForm = {
      componentName: FormsWidget,
    };
    setAnchorEl(null);
    globalContext.dispatch({
      type: CLOSE_WIDGET,
      payload: widgetForm,
    });
    setWidgetOpen(false);
  };

  // opening a form
  const openWidgetForm = () => {
    // todo lily pull Forms from utils with new work
    const widgetForm = {
      componentName: FormsWidget,
    };
    if (!isWidgetOpen) {
      globalContext.dispatch({
        type: OPEN_WIDGET,
        payload: widgetForm,
      });
    } else {
      setWidgetOpen(false);
      globalContext.dispatch({
        type: CLOSE_WIDGET,
        payload: widgetForm,
      });
    }
    setAnchorEl(null);
  };

  return (
    <Fragment>
      <StyledActionIcon
        Icon={BookIcon}
        disabled={isWidgetOpen}
        onClick={onOpen}
      />
      <Menu
        id="form-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={onClose}
        classes={{ list: classes.menuList }}
        PaperProps={{
          classes: {
            elevation8: classes.menuPaper,
          },
        }}
      >
        <ErrorBoundary>
          <Forms
            onClick={onClose}
            menuClick={openWidgetForm}
            embedded
            keycloak={keycloak}
            agency={agency}
            pim={pim}
          />
        </ErrorBoundary>
      </Menu>
    </Fragment>
  );
};
export default FormListMenu;
